module.exports = __webpack_public_path__ + "img/2-fourImg.4d28662b.png";